interface SearchLocationTranslationModel {
    locationPlaceholder: string;
    clearLocation: string;
}

const defaultSearchLocationTranslation: Required<SearchLocationTranslationModel> = {
    locationPlaceholder: 'Wpisz miasto lub region',
    clearLocation: 'Wyczyść lokalizację',
};

export { type SearchLocationTranslationModel, defaultSearchLocationTranslation };
